import { FC } from 'react'
import { MeetingInviteModal } from '../meeting/invite/MeetingInviteModal'
import useEmployeeDisplayTiny from '../../graphql/employee/hooks/useEmployeeDisplayTiny'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { SkillEmployeeStatusDto } from '../../types'

interface MeetingInviteContainerProps {
  employeeId: string | undefined | null
  closeDialog: () => void
  updateEmployeeSkillStatus?: (skillStatusData?: SkillEmployeeStatusDto) => void
}

export const MeetingInviteContainer: FC<MeetingInviteContainerProps> = ({ employeeId, closeDialog, updateEmployeeSkillStatus }) => {
  const { data, error, loading } = useEmployeeDisplayTiny(employeeId)

  if (error) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} />
  }

  const employee = (data && data.employeeDisplayTinyInfoByEmployeeId) || undefined

  return (
    <>
      {employee && (
        <MeetingInviteModal
          employeeList={[employee]}
          onCancel={closeDialog}
          updateEmployeeSkillStatus={
            updateEmployeeSkillStatus ? (skillStatusData?: SkillEmployeeStatusDto) => updateEmployeeSkillStatus(skillStatusData) : undefined
          }
          visible={!!employee}
        />
      )}
    </>
  )
}
